import React from 'react';
import PropTypes from 'prop-types';
import Filter from 'components/Filter';
import Form from 'components/Form';
import Input from 'components/Form/Input';
import { I18n } from 'react-redux-i18n';
import { TYPE_NUMBER } from 'components/Form/Input/input-type';
import { FormGroup } from 'reactstrap';

import './filter.scss';

class NumberRangeFilter extends React.Component {

    static propTypes = {
        title: PropTypes.string,
        defaultFrom: PropTypes.number,
        defaultTo: PropTypes.number,
        max: PropTypes.number,
        min: PropTypes.number,
        onApply: PropTypes.func,
        applied: PropTypes.bool,
        isForcedOpen: PropTypes.bool,
        disabled: PropTypes.bool,
        name: PropTypes.string,
    }

    static defaultProps = {
        title: '',
        defaultFrom: undefined,
        defaultTo: undefined,
        max: undefined,
        min: undefined,
        onApply: () => {},
        applied: false,
        isForcedOpen: false,
        disabled: false,
        name: undefined,
    }

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            errorMessage: undefined,
            inputFrom: undefined,
            inputTo: undefined,
        };

        this.anotherRef = React.createRef();
    }
    // After onApply, this conmponent will be re-render, all state been cleared.
    // For keep the applied value, we need to setState when componentDidMount
    componentDidMount() {
        const { defaultFrom, defaultTo  } = this.props;
        this.setState({
            inputFrom: defaultFrom,
            inputTo: defaultTo,
        });

    }

    componentDidUpdate(prevProps) {
        // when prev applied = true and then false. reset values
        const { applied } = this.props;

        if (applied === false && prevProps.applied === true) {
            this.setState({
                inputFrom: undefined,
                inputTo: undefined,
            });
        }
    }

    handleFilterReset = () => {
        const { onApply } = this.props;

        this.setState({
            open: false,
            inputFrom: undefined,
            inputTo: undefined,
        });

        onApply({
            from: undefined,
            to: undefined,
        });
    }

    handleFilterApply = () => {
        const { onApply } = this.props;
        const { inputFrom, inputTo } = this.state;

        this.setState({
            open: false,
        });

        onApply({
            from: Number(inputFrom),
            to: Number(inputTo)
        });
    }

    handleFilterToggle = () => {
        const { open } = this.state;
        const { disabled } = this.props;
        if (!disabled) {
            this.setState({
                open: !open,
            });
        }
    }

    handleFilterClickOutside = () => {
        this.setState({ open: false });
    }

    handleChange = field => e => {
        e.preventDefault();

        const { min, max, isForcedOpen, onApply } = this.props;
        const { value } = e.target;
        let updateNumber = value !== '' ? Number(value) : undefined;
        updateNumber = Number.isNaN(updateNumber) ? undefined : updateNumber;

        const updatedState = {
            ...this.state,
            [field]: updateNumber,
        };
        const { inputFrom, inputTo } = updatedState;

        if (min > updateNumber) {
            updatedState.errorMessage = I18n.t('validation_error.rangeUnderflow');
        }
        else if (max < updateNumber) {
            updatedState.errorMessage = I18n.t('validation_error.rangeOverflow');
        }
        else if (typeof inputTo !== 'number' || typeof inputFrom !== 'number') {
            updatedState.errorMessage = I18n.t('validation_error.require_both_numbers');
        }
        else if (inputTo < inputFrom) {
            updatedState.errorMessage = I18n.t('validation_error.wrong_order_of_numbers');
        }
        else {
            updatedState.errorMessage = '';
        }

        if (inputFrom === undefined && inputTo === undefined) {
            updatedState.errorMessage = '';
        }

        this.setState(updatedState);

        if (isForcedOpen) {
            onApply({
                from: updatedState.inputFrom,
                to: updatedState.inputTo,
            });

            if (this.anotherRef.current) {
                this.anotherRef.current.setCustomErrorMessage('');
            }
            e.target.setCustomErrorMessage(updatedState.errorMessage);
            if (updatedState.errorMessage?.length) {
                this.anotherRef.current = e.target;
                e.target.reportValidity();
            }
        }
    }

    getTitle = () => {
        const { applied, title, defaultFrom, defaultTo, isForcedOpen } = this.props;

        let displayTitlle = title;
        if (!isForcedOpen) {
            if (
                applied &&
                typeof defaultFrom === 'number' &&
                typeof defaultTo === 'number'
            ) {
                displayTitlle = `${ title }: ${ defaultFrom } -  ${ defaultTo }`;
            }
        }

        return displayTitlle;
    }

    render() {
        const { applied, min, max, isForcedOpen, disabled, name } = this.props;
        const { open, errorMessage, inputFrom, inputTo } = this.state;

        return (
            <Filter
                className="number-range-filter"
                value={ this.getTitle() }
                open={ open }
                applied={ applied }
                errorMessage={ errorMessage }
                onToggle={ this.handleFilterToggle }
                onReset={ this.handleFilterReset }
                onApply={ this.handleFilterApply }
                onClickOutside={ this.handleFilterClickOutside }
                isForcedOpen={ isForcedOpen }
            >
                <Form inline tag="div">
                    <FormGroup>
                        <Input
                            caption="from"
                            className="form-control"
                            type={ TYPE_NUMBER }
                            value={ inputFrom }
                            min={ min }
                            max={ max }
                            onChange={ this.handleChange('inputFrom') }
                            required={ isForcedOpen ? false : true }
                            disabled={ disabled }
                            name={ name ? `${name}_from`: undefined }
                        />
                    </FormGroup>
                    <FormGroup>
                        <Input
                            caption="to"
                            className="form-control"
                            type={ TYPE_NUMBER }
                            value={ inputTo }
                            min={ min }
                            max={ max }
                            onChange={ this.handleChange('inputTo') }
                            required={ isForcedOpen ? false : true }
                            disabled={ disabled }
                            name={ name ? `${name}_to`: undefined }
                        />
                    </FormGroup>
                </Form>
            </Filter>
        );
    }
}
export default NumberRangeFilter;
